import {
  RECONNECT_BASE_DELAY_MS,
  RECONNECT_MAX_DELAY_MS,
} from './WebSocket.constants'

// Builds the realtime-stream endpoint for one player. The server only sends
// events whose player_id matches, so the page never receives other players'.
export const buildSocketUrl = (baseUrl, playerId) => {
  if (!baseUrl || !playerId) {
    return null
  }

  const params = new URLSearchParams({ player_id: playerId })
  return `${baseUrl.replace(/\/+$/, '')}/ws?${params}`
}

export const getReconnectDelay = (attempt) =>
  Math.min(RECONNECT_BASE_DELAY_MS * 2 ** attempt, RECONNECT_MAX_DELAY_MS)

// Returns the parsed message, or null for non-JSON frames such as "pong".
export const parseMessage = (data) => {
  try {
    const message = JSON.parse(data)
    return message && typeof message === 'object' ? message : null
  } catch {
    return null
  }
}

export const isForPlayer = (message, playerId) =>
  Boolean(playerId) && message?.player_id === playerId

// The balance reducer reads player_id, amount and currency_code; the event
// payload is the wallet balance, which names the currency alphabetic_code.
export const toBalanceUpdate = (message) => ({
  player_id: message?.player_id,
  amount: message?.payload?.amount,
  currency_code: message?.payload?.alphabetic_code,
})
